import type { Practitioner } from '@medplum/fhirtypes';

import { Text } from '@eluve/components';

import type { FhirView } from '../../core/view-contract';
import { formatHumanName } from '../accessors';

/**
 * Practitioner is a reference target (requester, performer, asserter), not a
 * section: it renders as the practitioner's name inline wherever a parent
 * places its slot.
 */
export const PractitionerView: FhirView<Practitioner> = ({ data }) => {
  const qualification = data.qualification?.[0]?.code?.text;
  const name = formatHumanName(data.name?.[0]) || 'Practitioner';
  return (
    <Text
      inline
      size="sm"
      weight="regular"
      className="truncate"
      data-view="practitioner-inline"
    >
      {name}
      {qualification ? `, ${qualification}` : ''}
    </Text>
  );
};
